import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  getQuickTextTemplates,
  addQuickTextTemplate,
  updateQuickTextTemplate,
  deleteQuickTextTemplate,
} from "app/services/quickTextTemplate/quickTextTemplateService";
import { BASE_URL } from "static/constants";
import { checkIsCurrentUserOfClinic } from "utils/currentUser.util";

export const quickTextTemplateApi = createApi({
  reducerPath: "QuickTextTemplatesApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["QuickTextTemplates"],
  endpoints: ({ query, mutation }) => ({
    getQuickTextTemplates: query({
      queryFn: ({ query }) => {
        if (!checkIsCurrentUserOfClinic()) {
          return { data: [] };
        }

        return { data: getQuickTextTemplates(query) };
      },
      providesTags: ["QuickTextTemplates"],
    }),
    addQuickTextTemplate: mutation({
      queryFn: (payload) => {
        return {
          data: addQuickTextTemplate(payload),
        };
      },
      invalidatesTags: ["QuickTextTemplates"],
    }),
    updateQuickTextTemplate: mutation({
      queryFn: (payload) => {
        return {
          data: updateQuickTextTemplate(payload),
        };
      },
      invalidatesTags: ["QuickTextTemplates"],
    }),
    deleteQuickTextTemplate: mutation({
      queryFn: (templateId) => {
        return {
          data: deleteQuickTextTemplate(templateId),
        };
      },
      invalidatesTags: ["QuickTextTemplates"],
    }),
  }),
});

export const {
  useGetQuickTextTemplatesQuery,
  useAddQuickTextTemplateMutation,
  useUpdateQuickTextTemplateMutation,
  useDeleteQuickTextTemplateMutation,
} = quickTextTemplateApi;
